<template>
  <message-dialog :dialog="showDialog" :ok-button-loading="resending" :fullscreen="$vuetify.display.mobile" @cancel="$emit('close')" @ok="resend">
    <template v-if="$vuetify.display.mobile" #header>
      <header-mobile header-mobile post-background>
        <template #item-middle>
          <div class="font-weight-bold">{{ $translate("EmailConfirmationDialog.header") }}</div>
        </template>
      </header-mobile>
    </template>
    <template v-else #title>{{ $translate("EmailConfirmationDialog.header") }}</template>
    <template #content>
      <div>{{ $translate("EmailConfirmationDialog.content", { name: configuration.appTitle }) }}</div>
      <div class="mt-6">{{ $translate("EmailConfirmationDialog.haventReceived") }}</div>
    </template>
    <template #cancel>{{ $translate("common.close") }}</template>
    <template #ok>{{ $translate("EmailConfirmationDialog.resend") }}</template>
  </message-dialog>
</template>

<script>
import { mapGetters } from "pinia"

import { useConfigurationStore } from "@/store/configuration.js"

import * as accountsApi from "@/api/accountsApi.js"

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      resending: false
    }
  },
  computed: {
    ...mapGetters(useConfigurationStore, ["configuration"])
  },
  methods: {
    async resend() {
      try {
        this.resending = true
        await accountsApi.resendEmailConfirmation()
        this.$eventBus.$emit("notify", this.$translate("EmailConfirmationDialog.emailSent"))

        this.$emit("close")
      } catch (err) {
        this.$reportError(err, this.$translate("common.somethingWrong"))
      } finally {
        this.resending = false
      }
    }
  }
}
</script>
